// extracted by mini-css-extract-plugin
module.exports = {"container":"Error404_container__P6KJx","title":"Error404_title__oqqgz","subtitle":"Error404_subtitle__3Yi7j","action":"Error404_action__7i6Rv"};